<main class="main">
    <div class="main-wrapper">
        <section class="padding-first about1" id="about_us">
        <div class="container">

	        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
	            <div class="icon-back">
	                <span>Back</span>
	            </div>
	        </a>

	        <div>
	          	<div class="bl-rows">
		            <div class="text">
		                <h2>novae’s Voyage connected World is leveling up with Priceline Partner Networks</h2>
		                <span>By <strong>novae</strong> August 13, 2021</span>
		            </div>
		            <div class="img">
		                <img src="./assets/img/gennius/bg-inside-notice2.png">
		            </div>
	          	</div>
	        </div>

	          	<div class="bl-center">

		            <p>The development of disruptive user experiences, coupled with a seamless customer journey, has always been a fundamental motto for&nbsp;<strong>novae&rsquo;s</strong>&nbsp;<strong>solutions</strong>. Today we are proud to announce our partnership with&nbsp;<strong>Priceline Partner Networks</strong>, which revolutionizes Voyage Connected World &ndash; a new voyage experience where loyalty users can shop online, book travel virtually at their favorite stores, get access to first-seat entertainment or just get back to traveling around the world.&nbsp;</p>
					<p>This partnership marks the&nbsp;<strong>Voyage Connected World</strong>&nbsp;evolution, exponentially enhancing travel offerings and allowing for a more direct experience&nbsp;<strong>with Priceline Partner Network&rsquo;s&nbsp;</strong>world class travel deals. Priceline Partner Network is the distribution channel of Priceline.com,&nbsp;which is&nbsp;part of Booking Holdings Inc.,&nbsp;the world&rsquo;s leading provider of online travel and related services. &nbsp;</p>
					<p>Moreover, Priceline Partner Networks will offer access to hotel rates with up to 60% discount, over 300+ airlines and 29,000+ rental car locations worldwide.&nbsp;&nbsp;</p>
					<p>Concomitantly, Voyage Connected World continues to provide stellar features and functionalities such as combining traditional and innovative payment capabilities through an&nbsp;<strong>all-in-one digital currency - Miles.</strong>&nbsp;Users can book travel combining rewards with debit/credit cards with&nbsp;<strong>Invisible</strong>&nbsp;<strong>Split</strong>, buy now and pay later with&nbsp;<strong>Switch</strong>&nbsp;<strong>to</strong>&nbsp;<strong>Miles</strong>, pay with&nbsp;<strong>Installment</strong>&nbsp;<strong>Payments</strong>, and even pay with crypto through&nbsp;<strong>CryptMi</strong>. More importantly, users earn&nbsp;<strong>up to 10X miles with every transaction, even when booking with rewards</strong>; it&rsquo;s what we know as&nbsp;<strong>upperMiles</strong>.&nbsp;</p>
					<p>With incorporated&nbsp;<strong>automatic travel protection benefits</strong>&nbsp;like&nbsp;<strong>no fees for flight rebooking or cancellation, emergency medical assistance, COVID-19 protection, international purchase protection and instant compensation</strong>&nbsp;for unplanned events such&nbsp;as flight delays or cancellations, missed connections, baggage loss or delay, theft or damage of purchased goods and many other exclusive benefits.&nbsp;</p>
					<p>In summary, Voyage Connected World&rsquo;s users can now access more travel deals, earn more rewards, and pay the way they want while enjoying a 100%-digital experience and an always-on, always-ready support through WhatsApp, iMessage and Facebook Messenger.&nbsp;</p>

	          	</div>

	          	<div class="bl-center">

		            <div class="text-1"><span> “At Priceline Partner Network, we believe every trip is a big deal. Connecting novae’s Voyage Connect World to our world class hotel, flight and rental car deals allow us to broaden our mission and help millions of travelers be there for the moments that matter through novae’s offering of innovative payment options.”, said Kayla Dickin, Director of Partnerships, at Priceline Partner Networks.
		            </span></div>

		        </div>
		        <div class="bl-center">

		            <p>We are excited about this partnership, which will strengthen <strong>Voyage Connected World’s</strong> value proposition. Partnering with <strong>Priceline Partner Networks</strong> is yet another MILEStone in novae’s history and another opportunity to keep driving higher engagements and better business outcomes for our partners and customers. </p>

		        </div>






        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
